module.exports = __webpack_public_path__ + "img/save_w.d7a8b7bc.svg";